

  // Funkce pro přidání produktu do localStorage

if($('.type-detail').length){
  function addProductToLocalStorage(product) {
    let storedProducts = JSON.parse(localStorage.getItem('storedProducts'+document.location.host)) || [];  // Získání aktuálních dat z localStorage (pokud existují)
    const existingProductIndex = storedProducts.findIndex(p => p.id === product.id);   // Kontrola, zda již existuje produkt se stejným ID
    if (existingProductIndex !== -1) { // Produkt se stejným ID již existuje a odstraní se starší záznamu
      storedProducts.splice(existingProductIndex, 1);
    }
    storedProducts.unshift(product); // Vložení nového produktu na začátek seznamu
    const maxSize = 50; // Omezení velikosti seznamu na určitý počet produktů (např. 10)
    storedProducts = storedProducts.slice(0, maxSize);
    localStorage.setItem('storedProducts'+document.location.host, JSON.stringify(storedProducts)); // Uložení aktualizovaných dat zpět do localStorage
  }
  if($('.kalkulator').length){
    var productPrize = ''
  }
  else{
    var productPrize = $('.p-final-price-wrapper').html()
  }
  //const productPrize = $('.p-final-price-wrapper').html()
  const productId = $('#product-detail-form meta[itemprop="sku"]').attr('content'); // Získání ID produktu
  const productName = $('.p-detail-inner-header h1').text().trim(); // Získání názvu produktu
  const entry_url = window.location.pathname // získání url produktu
  const productDescription = $('.p-short-description').text().trim().substring(0, 97 - 3)
  if($('.p-detail-inner .flags.flags-default').length){
    var flags_default = $('.p-detail-inner .flags.flags-default').html()
  }
  else{
    var flags_default = ''
  }
  if($('.p-detail-inner .flags.flags-extra').length){
    var flag_action = $('.p-detail-inner .flags.flags-extra').html()
    var ActionPrice = parseFloat($('.p-detail-inner .flags.flags-extra .price-standard').text().replace(/ /g, '').replace(',', '.'))*obshabaleni
  }
  else{
    var flag_action = ''
    var ActionPrice = ''
  }
  
  //obrázky produktů
  if($('.p-thumbnails').length){
    var product_image = $('.p-thumbnails-inner a.p-thumbnail').eq(0).attr('href').replace('/big/', '/detail/')
    var product_image_second = $('.p-thumbnails-inner a.p-thumbnail:not(".frame-video")').eq(1).attr('href').replace('/big/', '/detail/')
  }
  else{
    var product_image = $('.p-image img').attr('src')
    var product_image_second = $('.p-image img').attr('src')

  }



  // Vytvoření objektu s daty produktu
  const productData = {
    id: productId,
    product_name: productName,
    product_url: entry_url,
    prvni_obrazek: product_image,
    druhy_obrazek: product_image_second,
    flags_default: flags_default,
    flag_action: flag_action,
    productUnit: cenaV,
    productPrizeCalc: productPrize,
    productPrize: cenazabaleni*obshabaleni,
    productActionPrice: ActionPrice,
    productDescription: productDescription,
  };
 
  addProductToLocalStorage(productData);  // Přidání produktu do localStorage
 
}


  if(localStorage.getItem('storedProducts'+document.location.host)){
    product_existing_item = JSON.parse(localStorage.getItem('storedProducts'+document.location.host));
    //naposledy prohlížené objekt
    var lastest_view = '<section class="latest-view" style="margin-bottom:25px;">'
    lastest_view += '<div class="container">'
    lastest_view += '<div class="homepage-group-title homepage-products-heading-2 h4">Naposledy prohlížené</div>'
    lastest_view += '<div class="products-wrapper"><div id="products-latest-view" class="products product-slider products-block">'
    for (var i = 0; i < product_existing_item.length; i++) {
        lastest_view += '<div class="product lastest-wiev">'
        lastest_view += '<div class="p">'
        lastest_view += '<a href="'+product_existing_item[i].product_url+'" class="image">'
        lastest_view += '<img src="'+product_existing_item[i].prvni_obrazek+'" class="swap-image">'
        if(product_existing_item[i].flags_default.length){
          lastest_view += '<div class="flags flags-default">'+product_existing_item[i].flags_default+'</div>'
        }
        if(product_existing_item[i].flag_action.length){
          lastest_view += '<div class="flags flags-extra">'+product_existing_item[i].flag_action+'</div>'
        }
        lastest_view += '</a>'
        lastest_view += '<div class="p-in">'
        lastest_view += '<div class="p-in-in">'
        lastest_view += '<a href="'+product_existing_item[i].product_url+'" class="name" data-micro="url">'
        lastest_view += product_existing_item[i].product_name
        lastest_view += '</a>'
        lastest_view += '<div class="p-bottom single-button no-buttons">'
        
        
       
          lastest_view += '<div data-micro="offer" data-micro-price="'+product_existing_item[i].price+'" data-micro-price-currency="'+getShoptetDataLayer().currency+'">'
          lastest_view += '<div class="prices">'
          if(product_existing_item[i].productPrize == null){
            lastest_view += '<div class="price-notStogare" data-testid="productCardPrice">'
            lastest_view += product_existing_item[i].productPrizeCalc
            lastest_view += '</div>'
          }
          else{
            if(product_existing_item[i].flag_action.length){
              lastest_view += '<span class="price-standard"><span>'+Number(Math.round(product_existing_item[i].productActionPrice)).ShoptetFormatAsCurrency()+'</span></span>'
            }
            lastest_view += '<div class="price price-final" data-testid="productCardPrice">'
            lastest_view += '<strong>'+Number(Math.round(product_existing_item[i].productPrize)).ShoptetFormatAsCurrency()+'</strong> <span class="pr-list-unit">/ '+product_existing_item[i].productUnit+'</span>'
            lastest_view += '</div>'
          }
          
          
         
        
        lastest_view += '</div>'
        lastest_view += '</div>'
        lastest_view += '<p class="p-desc" data-micro="description" data-testid="productCardShortDescr">'+product_existing_item[i].productDescription+'</p>'
        lastest_view += '</div>'
        lastest_view += '</div>'
        lastest_view += '</div>'
        lastest_view += '<span class="no-display" data-micro="sku">'+product_existing_item[i].id+'</span>'
        lastest_view += '</div>'
        lastest_view += '</div>'
    }
    lastest_view += '</div>'
    lastest_view += '</div></div>'
    lastest_view += '</section>'

    $('.in-index .welcome-wrapper').before(lastest_view)
    $('.type-category #content-wrapper').append(lastest_view)
    $('.type-detail #content-wrapper').append(lastest_view)
    $(document).ready(function(){
      $('#products-latest-view').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow:3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1284,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
          
        ]
      });
    })
    
  }
